/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { TierStepsResponseDTO } from './TierStepsResponseDTO';

export type StartUpgradeTierResponseDTO = {
    generalProcessStatus?: StartUpgradeTierResponseDTO.generalProcessStatus;
    processId?: string;
    tierSteps?: Array<TierStepsResponseDTO>;
    tierType?: StartUpgradeTierResponseDTO.tierType;
};

export namespace StartUpgradeTierResponseDTO {

    export enum generalProcessStatus {
        STARTED = 'STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
        DISCARDED = 'DISCARDED',
        BLOCKED = 'BLOCKED',
    }

    export enum tierType {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

